import { Tag } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  PlayCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { EGiveawayStatus } from "../../../../enums";

interface IProps {
  status: EGiveawayStatus | string;
  isValid: boolean;
}

export default function GiveawayStatusTag({ status, isValid }: IProps) {
  let color = "#8c8c8c";
  let icon: React.ReactNode = null;

  if (!isValid) {
    color = "#ff4d4f";
    icon = <CloseCircleOutlined />;
  } else {
    switch (status) {
      case EGiveawayStatus.FINISHED:
      case "Finalizado":
        color = "#52c41a";
        icon = <CheckCircleOutlined />;
        break;
      case EGiveawayStatus.UNDER_VERIFICATION:
      case "Em verificação":
        color = "#faad14";
        icon = <ClockCircleOutlined />;
        break;
      case EGiveawayStatus.WAITING_RAFFLE:
      case "Aguardando sorteio":
        color = "#1677ff";
        icon = <ClockCircleOutlined />;
        break;
      case EGiveawayStatus.WAITING_NEW_RAFFLE:
      case "Aguardando novo sorteio":
        color = "#13c2c2";
        icon = <SyncOutlined />;
        break;
      case EGiveawayStatus.FORCE:
      case "Vigente":
        color = "#722ed1";
        icon = <PlayCircleOutlined />;
        break;
      case EGiveawayStatus.IMPORT_PERIOD:
      case "Periodo de importação":
        color = "#2f54eb";
        icon = <ClockCircleOutlined />;
        break;
      case EGiveawayStatus.ON_HOLD:
      case "Em espera":
        color = "#fa8c16";
        icon = <ClockCircleOutlined />;
        break;
      default:
        color = "#8c8c8c";
        icon = null;
    }
  }

  const statusText = isValid ? status : "Inválido";

  return (
    <Tag
      style={{
        backgroundColor: color + "18",
        color: color,
        fontWeight: 600,
        borderRadius: 12,
        border: `1px solid ${color}40`,
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        width: "fit-content",
        gap: 5,
        padding: "2px 8px",
        margin: 0,
      }}
    >
      {icon}
      {statusText}
    </Tag>
  );
}
